module.exports = __webpack_public_path__ + "img/heroimage@2x.956e4183.png";